import React from 'react';
import { Typography } from '@mui/material';
import { ContractView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Facility type template
 */
export const FacilityTypeTemplate: React.FC<{ facilityType: string | null | undefined }> = ({
  facilityType,
}) => <Typography variant="body2">{facilityType || '-'}</Typography>;

// Template function for grid column
export const facilityTypeTemplate = (rowData: ContractView) => (
  <FacilityTypeTemplate facilityType={rowData.facilityType} />
);

export default FacilityTypeTemplate;
